<template>
  <a-modal
    title="历史审稿意见"
    v-model="visible"
    :dialog-style="{ top: '30px' }"
    width="800px"
    @cancel="() => (this.visible = false)"
    :destroyOnClose="true"
    :footer="null"
    :maskClosable="false"
  >
    <div
      class="opinion"
      v-for="(item, index) in opinionList"
      :key="item.opinionCode"
      style="margin-top: 20px"
    >
      <a-row style="border-bottom: 1px solid #d9d9d9">
        <a-col :span="2">
          <div style="position: relative; width: 20px; height: 20px">
            <img src="../../assets/round.png" alt style="width: 20px" />
            <div
              style="
                position: absolute;
                width: 20px;
                height: 20px;
                z-index: 2;
                left: 5px;
                top: 0;
                font-size: 16px;
                color: white;
              "
            >
              {{ index + 1 }}
            </div>
          </div>
        </a-col>
        <a-col :span="22">
          <a-row class="row" style="margin-bottom: 20px">
            <label v-if="item.auditType == 1">责编</label>
            <label v-else-if="item.auditType == 2">外审专家</label>
            <label v-else>副主编/主编</label>
            ：{{ item.auditer }}
            <label style="margin-left: 20px">审稿结论：</label>
            <label v-if="item.result == 33">退改</label>
            <label v-if="item.result == 44">退稿</label>
            <label v-if="item.result == 4">一审通过</label>
            <label v-if="item.result == 5">二审通过</label>
            <label v-if="item.result == 6">三审通过</label>
            <label v-if="item.result == 7">送外审</label>
            <label v-if="item.result == 8">专家审核完成</label>
            <label v-if="item.result == 9">一校通过</label>
            <label v-if="item.result == 10">二校通过</label>
            <label v-if="item.result == 11">三校通过</label>
            <label v-if="item.result == 12">采用</label>
            <label style="margin-left: 20px">审核时间：</label>
            {{ item.auditTime }}
          </a-row>
          <a-row class="row" style="margin-bottom: 20px">
            <a-col :span="4">
              <label class="title2">稿件意见：</label>
            </a-col>
            <a-col :span="20">
              <label>{{ item.note }}</label>
            </a-col>
          </a-row>
        </a-col>
      </a-row>
    </div>
  </a-modal>
</template>

<script>
export default {
  name: "AuditOpinion",
  props: {
    infoData: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      visible: false,
      code: "",
      opinionList: [],
    };
  },
  mounted() {},
  methods: {
    show() {
      this.$nextTick(() => {
        this.visible = true;
        this.code = this.infoData.code;
        this.getAuditList();
      });
    },
    getAuditList() {
      this.axios
        .get("/auditOpinion/queryAllOpinion", {
          params: {
            code: this.code,
            isSubmit: 1,
            time: new Date().getTime(),
          },
        })
        .then((res) => {
          if (res.data.code == "OK") {
            this.opinionList = res.data.data;
          } else {
            this.utils.messageInfo(this, "error", "查询历史审稿意见失败！");
          }
        });
    },
  },
};
</script>

<style>
</style>